import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useAnalyticsTracking from '../hooks/useAnalyticsTracking';

const AnalyticsProvider = ({ children }) => {
    const auth = useSelector((state) => state.auth?.isLogin);
    const token = localStorage.getItem('dizeeToken');
    
    // Only initialize analytics tracking for authenticated users
    const { isTracking } = useAnalyticsTracking();
    
    useEffect(() => {
        if (auth && token && isTracking) {
            console.log('📊 Analytics tracking initialized for authenticated user');
        }
    }, [auth, token, isTracking]);
    
    return children;
};

export default AnalyticsProvider; 